__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@maui-mf/app-threat-personalization";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.3", () => (Promise.all([__webpack_require__.e(504), __webpack_require__.e(154)]).then(() => (() => (__webpack_require__(4504))))));
			register("@maui/icon-data", "1.14.3", () => (__webpack_require__.e(637).then(() => (() => (__webpack_require__(6637))))));
			register("@maui/react-query", "1.2.1", () => (Promise.all([__webpack_require__.e(154), __webpack_require__.e(966), __webpack_require__.e(737)]).then(() => (() => (__webpack_require__(1737))))));
			register("@maui/threat-personalization", "0.12.30", () => (Promise.all([__webpack_require__.e(524), __webpack_require__.e(154), __webpack_require__.e(789), __webpack_require__.e(289), __webpack_require__.e(300)]).then(() => (() => (__webpack_require__(3300))))));
			register("@maui/vt-icons", "0.2.1", () => (Promise.all([__webpack_require__.e(154), __webpack_require__.e(357), __webpack_require__.e(224)]).then(() => (() => (__webpack_require__(9357))))));
			register("@nautilusjs/mati-apis", "1.15.1", () => (Promise.all([__webpack_require__.e(649), __webpack_require__.e(154), __webpack_require__.e(789), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(5649))))));
			register("@nivo/core", "0.84.0", () => (Promise.all([__webpack_require__.e(610), __webpack_require__.e(378), __webpack_require__.e(154), __webpack_require__.e(186), __webpack_require__.e(858), __webpack_require__.e(598)]).then(() => (() => (__webpack_require__(3378))))));
			register("@nivo/line", "0.84.0", () => (Promise.all([__webpack_require__.e(610), __webpack_require__.e(434), __webpack_require__.e(964), __webpack_require__.e(154), __webpack_require__.e(186), __webpack_require__.e(858), __webpack_require__.e(217)]).then(() => (() => (__webpack_require__(5964))))));
			register("@nivo/scatterplot", "0.84.0", () => (Promise.all([__webpack_require__.e(610), __webpack_require__.e(434), __webpack_require__.e(600), __webpack_require__.e(154), __webpack_require__.e(186), __webpack_require__.e(858), __webpack_require__.e(360)]).then(() => (() => (__webpack_require__(6600))))));
			register("@tanstack/react-query", "4.2.3", () => (Promise.all([__webpack_require__.e(854), __webpack_require__.e(154)]).then(() => (() => (__webpack_require__(4854))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(623), __webpack_require__.e(154)]).then(() => (() => (__webpack_require__(5623))))));
			register("react-router-dom", "6.20.1", () => (Promise.all([__webpack_require__.e(900), __webpack_require__.e(154), __webpack_require__.e(186)]).then(() => (() => (__webpack_require__(8900))))));
			register("react", "17.0.2", () => (__webpack_require__.e(326).then(() => (() => (__webpack_require__(6326))))));
			initExternal(615);
			initExternal(9252);
			initExternal(955);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};